<template>
    <div class="doc-share flex flex-col border-box full-height">
        <div class="body full-width flex flex-col" >
            <div class="full-width flex flex-center-sp margin-bottom-l font-l ">
                来自<span class="font-bold">「{{userName}}」</span>的分享文档 <span class="font-bold">『{{docName}}』</span> 
            </div>
            <div v-if="type == 1 && result == 1" class="full-width flex flex-center-sp margin-top-m">
                <input style="width: 300px;" class="ui-input " placeholder="请输入分享口令" type="text"  v-model="inputValue" ref="getfocus"/>
            </div>
            <div v-if="type == 1 && result == 1"  class="full-width flex flex-center-sp margin-top-xl" >
                <div class="margin-top-l btn-blue-full border-radius-xxl pointer font-s w300" @click="confirm" >确定</div>
            </div>    

            <div v-if="result == 0"  class="full-width flex flex-center-sp font-l font-bold" style="margin-top:50px">
                <img  style="width:40px;height:40px;" src="@/assets/images/warn.png"/>
            </div>
        
            <div v-if="result == 0"  class="full-width flex flex-center-sp font-l font-bold" style="margin-top:20px">
                {{msg}}
            </div>

        </div>

    </div>
</template>

<script>
    import {getDocShare,getShareId} from '@/api/api'
    import { isMobile } from '../utils/sysUtils';
    export default{
        name:'DocShare',
        data() {
            return {
                id:null,
                inputValue:"",
                docName:"",
                userName:"",
                showMsg: false,
                msg: "",
                type: 0,
                result: 0,
            }
        },
        created() {
            this.id = this.$route.params.id;
            getDocShare(this.id).then((res)=> {
                console.log(res);
                if (res.data.success == true) {
                    this.docName = res.data.result.docName;
                    this.userName = res.data.result.userName;
                    this.type = res.data.result.type;
                    this.result = res.data.result.result;
                    this.msg =  res.data.result.message;
                    if (res.data.result.type == 0 && res.data.result.result == 1 ) {
                        if (isMobile()) {
                            this.$router.push({
                                path: '/mdoc?shareId=' + res.data.result.id
                            })
                        } else if (res.data.result.docType == "default")  {
                            this.$router.push({
                                path: '/doc?shareId=' + res.data.result.id
                            })
                        } else {
                            this.$router.push({
                                path: '/doc?id=' + res.data.result.docId
                            })
                        }
                    }  
                } else {
                    this.msg = res.data.message;
                    this.showMsg = true;
                }

            })
        },
        methods:{
            confirm() {
                getShareId(this.id, this.inputValue).then((res)=> {
                    console.log(res);
                    if (res.data.result == null) {
                        this.$showToast({msg: '口令错误！' });    
                        return;
                    } else {
                        this.$router.push({
                            path: '/doc?shareId=' + res.data.result.id
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
   .doc-share .body {
        position: fixed;
        left:0;
        right: 0;
        top: 30%;
   }

</style>


// WEBPACK FOOTER //
// src/views/DocShare.vue